/* eslint-disable @typescript-eslint/ban-ts-comment */
import useSWR from 'swr'
import { SummitResponse, defaultState } from '../fetchSummit'
import fetcher from '../fetcher'
import convertMinutesToMilliseconds from '../convertMinutesToMilliseconds'
import useGigIDs from '../useGigIDs'

/** Will pass the initial state from the Summit object, then revalidate. Subsequent calls won't need to pass initial state as it will be cached */
const useSummit = (initialData: SummitResponse = defaultState, hostUrl = '') => {

  const { channelId, webcastId } = useGigIDs()

  // @ts-ignore
  return useSWR<SummitResponse, any>(channelId && webcastId ? [ 'summit', hostUrl, '', channelId, webcastId ] : null, fetcher, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error.status === 404) return

      // Retry every minute on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), convertMinutesToMilliseconds(2))

    },
    initialData,
    revalidateOnMount: false,
    revalidateOnFocus: false
  })

}

export default useSummit
